<template>
  <main>
    <!-- <v-data-table :headers="headers" :items="camps" hide-default-footer></v-data-table> -->
    <v-container>
      <v-toolbar flat class="main-header mb-10 px-0">
        <v-toolbar-title class="main-header__title">
          <h1>
            <v-btn
              @click="back"
              outlined
              class="mr-3 px-0 m-w-50"
              large
              color="primary"
              ><v-icon>mdi-arrow-left</v-icon></v-btn
            >Schedules
          </h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items
          class="main-header__contents"
          v-if="schedules.length < 3"
        >
          <v-btn
            class="my-auto mx-1 radius-12"
            color="success"
            :to="
              `/camp-types/${$route.params.id}/sub-types/${$route.params.slug}/schedules/create`
            "
            v-if="
              permissions.includes(
                'store_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules'
              )
            "
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />
      <v-data-table
        :headers="headers"
        :items="schedules"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        hide-default-footer
        class="table teams"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell text-center">
              <v-img
                height="50px"
                width="70px"
                class="radius-12 mx-auto"
                v-if="item.photo != null"
                :src="item ? item.photo : '--'"
              ></v-img>
              <span v-else>---</span>
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.name : "---" }}
            </td>
            <td class="table__cell name text-center">
              <span v-if="item.classification == null">
                Single Team
              </span>
              <span v-else> Multiple Teams '{{ item.classification }}' </span>
            </td>

            <td class="text-center">
              <v-btn
                color="primary"
                rounded
                large
                :to="
                  `/camp-types/${$route.params.id}/sub-types/${$route.params.slug}/schedules/${item.id}/details`
                "
                v-if="
                  permissions.includes(
                    'index_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}_details'
                  )
                "
                ><small>Schedule Details</small></v-btn
              >
              <span v-else>---</span>
            </td>

            <td class="table__cell text-center">
              <router-link
                :to="
                  `/camp-types/${$route.params.id}/sub-types/${$route.params.slug}/schedules/edit/${item.id}`
                "
                class="hovering mr-1 edit"
                v-if="
                  permissions.includes(
                    'update_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}'
                  )
                "
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span
                v-if="
                  permissions.includes(
                    'destroy_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}'
                  )
                "
                @click="handleDelete(item, index)"
                class="hovering delete"
              >
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
              <span v-else>---</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </main>
</template>

<script>
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      reserved_headers: [],
      schedules: [],
      dialog: false,
      panel: [0, 1],
      currentTeamId: null,
      camp_team: [],
      camp: {},
      team_id: 0,
      team_index: "",
      isEdit: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.indexSchedules();
    this.createTableHeaders();
  },
  methods: {
    indexSchedules() {
      IndexData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules`
      })
        .then(res => {
          const { data } = res.data;
          this.schedules = data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    handleShow({ id }) {
      this.currentTeamId = id;
      this.dialog = true;
    },
    handleEditTeam(team) {
      this.$set(this.available_teams, this.team_index, team);
      this.isEdit = false;
    },
    handleEdit({ id }, index) {
      this.scrollTop();
      this.team_id = id;
      this.team_index = index;
      this.isEdit = true;
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules`,
            id: id
          })
            .then(() => {
              this.schedules.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    },
    createTableHeaders() {
      const headersList = [
        "Pic",
        "Title",
        "Classification",
        "Schedule Details",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
      this.reserved_headers = TableHeaders(
        headersList.filter(e => e !== "Enabled")
      );
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    back() {
      history.go(-1);
    }
  }
};
</script>
